export default __webpack_public_path__ + "static/react_code_example-fa3d7a201628fa54df6bbf2944346b03.png";